import React from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import { Modal, Button, Progress, Card, Statistic, Timeline } from 'antd';

import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.css';

class Test extends React.Component {

    constructor(props) {
        super(props);

        this.state = { isModalVisible: false };

        this.pickObj = null;
        this.pickMaterial = null;
        this.SMaterial = new THREE.MeshStandardMaterial({
            color: 0xff0000,
            metalness: 0.85,
            roughness: 0.25,
        });

        this.miniScene = null;
        this.miniCamera = null;
        this.miniControls = null;
        this.miniCW = 0;
        this.miniCH = 0;
    }

    componentDidMount() {

        // 获得DOM节点
        // document.body.appendChild(stats.dom);
        const EL = document.getElementById('zrf');
        const canvasW = EL.clientWidth;
        const canvasH = EL.clientHeight;

        // 显示帧数
        const stats = new Stats();
        EL.appendChild(stats.dom);

        // 创建场景
        const scene = new THREE.Scene();

        const S = 20;
        const camera = new THREE.OrthographicCamera(canvasW / - S, canvasW / S, canvasH / S, canvasH / - S, 1, 1000);
        camera.position.z = 500;
        camera.position.x = 0;
        camera.position.y = 100;
        // 添加相机
        scene.add(camera);

        // 创建renderer
        const renderer = new THREE.WebGLRenderer({ antialias: true });
        renderer.setSize(canvasW, canvasH);
        renderer.physicallyCorrectLights = true;
        renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.setClearColor(0x669999);
        //像素
        renderer.setPixelRatio(window.devicePixelRatio);
        EL.appendChild(renderer.domElement);


        // const geometry = new THREE.BoxGeometry();
        // const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
        // const cube = new THREE.Mesh(geometry, material);
        // scene.add(cube);

        //环境光
        let ablight = new THREE.AmbientLight(0xFFFFFF, 2);
        scene.add(ablight);

        let light = new THREE.DirectionalLight(0xFFFFFF, 1 * Math.PI);
        light.position.set(-150, 50, 0);
        scene.add(light);

        //HDR 环境光
        let pmremGenerator = new THREE.PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();
        new RGBELoader()
            .setDataType(THREE.UnsignedByteType)
            .load(process.env.PUBLIC_URL +
                '/hdr/1k.hdr', function (texture) {

                    let envMap = pmremGenerator.fromEquirectangular(texture).texture
                    envMap.isPmremTexture = true
                    pmremGenerator.dispose()

                    // 这两个可以分开设置
                    scene.environment = envMap  // 给场景添加环境光效果
                    // scene.background = envMap // 给场景添加背景图
                })


        // 创建controls
        const controls = new OrbitControls(camera, renderer.domElement);
        // controls.autoRotate = true;
        controls.update();

        const animate = function () {
            requestAnimationFrame(animate);

            // cube.rotation.x += 0.01;
            // cube.rotation.y += 0.01;

            stats.update();
            controls.update();

            renderer.render(scene, camera);
        };

        animate();


        // 模型加载
        const loader = new GLTFLoader()
        loader.load(process.env.PUBLIC_URL +
            '/models/gzxtzc.glb',
            (gltf) => {
                // called when the resource is loaded
                console.log('模型加载完成');
                // console.log('gltf', gltf)

                // 定位
                let box = new THREE.Box3().setFromObject(gltf.scene);
                let size = box.getSize(new THREE.Vector3()).length();
                let center = box.getCenter(new THREE.Vector3());

                gltf.scene.position.x += (gltf.scene.position.x - center.x);
                gltf.scene.position.y += (gltf.scene.position.y - center.y);
                gltf.scene.position.z += (gltf.scene.position.z - center.z);
                gltf.scene.name = 'GModels'
                scene.add(gltf.scene);

                camera.near = size / 100;
                camera.far = size * 100;
                camera.left = canvasW / (-1600 / size);
                camera.right = canvasW / (1600 / size);
                camera.top = canvasH / (1600 / size);
                camera.bottom = canvasH / (-1600 / size);
                // camera.lookAt(center);
                camera.updateProjectionMatrix();


            },
            (xhr) => {
                // called while loading is progressing
                console.log(`${(xhr.loaded / xhr.total * 100)}% loaded`);
            },
            (error) => {
                // called when loading has errors
                console.error('An error happened', error);
            },
        );

        // 鼠标拾取
        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();

        //双击鼠标左键
        renderer.domElement.addEventListener("dblclick", (event) => {
            //console.log(event)

            let rect = renderer.domElement.getBoundingClientRect();
            mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

            // this.ToPick(raycaster, mouse);
            raycaster.setFromCamera(mouse, camera);
            let intersects = raycaster.intersectObjects(scene.children, true);
            //恢复上次pick
            if (this.pickObj != null) {
                this.pickObj.material = this.pickMaterial;
            }
            if (intersects.length > 0) {
                let obj = intersects[0].object;
                //保存当前pick
                this.pickObj = obj;
                this.pickMaterial = obj.material;

                obj.material = this.SMaterial;
                obj.material.needsUpdate = true;

                // if (obj.userData.anim) {
                //     obj.userData.anim = null
                //     obj.position.z = obj.position.z - 50
                // } else {
                //     obj.userData.anim = 'yes'
                //     obj.position.z = obj.position.z + 50
                // }

                this.setState({
                    isModalVisible: true
                })

                this.showMini()
            }
        })




    }

    componentWillUnmount() {

    }

    showMini() {

        // console.log(this.miniScene)
        if (this.miniScene) {
            //清空
            this.miniScene.children.forEach(item => {
                if (item.type === 'Mesh') {
                    this.miniScene.remove(item);
                }
            });

            // controls重置
            this.miniControls.reset();
            this.miniControls.update();

            //加载模型
            let miniobj = this.pickObj.clone();
            miniobj.material = this.pickMaterial;

            // 定位
            let box = new THREE.Box3().setFromObject(miniobj);
            let size = box.getSize(new THREE.Vector3()).length();
            miniobj.position.x = 0
            miniobj.position.y = 0
            miniobj.position.z = 0

            this.miniScene.add(miniobj);

            // this.miniCamera.near = size / 100;
            // this.miniCamera.far = size * 100;
            this.miniCamera.left = this.miniCW / (-600 / size);
            this.miniCamera.right = this.miniCW / (600 / size);
            this.miniCamera.top = this.miniCH / (600 / size);
            this.miniCamera.bottom = this.miniCH / (-600 / size);
            // camera.lookAt(center);
            this.miniCamera.updateProjectionMatrix();


        } else {
            //创建
            let MC = document.getElementById('minicanvas');
            let miniCW = MC.clientWidth;
            let miniCH = MC.clientHeight;
            this.miniCW = miniCW;
            this.miniCH = miniCH;

            const miniScene = new THREE.Scene()
            this.miniScene = miniScene;

            let miniRenderer = new THREE.WebGLRenderer({ antialias: true });
            let S = 10;
            // let miniCamera = new THREE.PerspectiveCamera(75, miniCW / miniCH, 0.1, 1000);
            // miniCamera.position.z = 50;

            const miniCamera = new THREE.OrthographicCamera(miniCW / - S, miniCW / S, miniCH / S, miniCH / - S, 1, 1000);
            miniCamera.position.z = 500;
            miniCamera.position.x = 0;
            miniCamera.position.y = 200;
            this.miniCamera = miniCamera;

            //环境光
            let ablight = new THREE.AmbientLight(0xFFFFFF, 2);
            miniScene.add(ablight);

            let pmremGenerator = new THREE.PMREMGenerator(miniRenderer);
            pmremGenerator.compileEquirectangularShader();
            //HDR 环境光
            new RGBELoader()
                .setDataType(THREE.UnsignedByteType)
                .load(process.env.PUBLIC_URL +
                    '/hdr/1k.hdr', function (texture) {

                        let envMap = pmremGenerator.fromEquirectangular(texture).texture
                        envMap.isPmremTexture = true
                        pmremGenerator.dispose()

                        // 这两个可以分开设置
                        miniScene.environment = envMap  // 给场景添加环境光效果
                        // miniScene.background = envMap // 给场景添加背景图
                    })

            // let geometry = new THREE.BoxGeometry();
            // let material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
            // let cube = new THREE.Mesh(geometry, material);
            // miniScene.add(cube);

            let miniobj = this.pickObj.clone();
            miniobj.material = this.pickMaterial;

            // 定位
            let box = new THREE.Box3().setFromObject(miniobj);
            let size = box.getSize(new THREE.Vector3()).length();

            console.log(box, size, miniobj)

            miniobj.position.x = 0
            miniobj.position.y = 0
            miniobj.position.z = 0

            miniScene.add(miniobj);

            // miniCamera.near = size / 100;
            // miniCamera.far = size * 100;
            miniCamera.left = miniCW / (-600 / size);
            miniCamera.right = miniCW / (600 / size);
            miniCamera.top = miniCH / (600 / size);
            miniCamera.bottom = miniCH / (-600 / size);
            // camera.lookAt(center);
            miniCamera.updateProjectionMatrix();


            let miniControls = new OrbitControls(miniCamera, miniRenderer.domElement);
            miniControls.autoRotateSpeed = 4;
            miniControls.autoRotate = true;
            miniControls.saveState();
            miniControls.update();
            this.miniControls = miniControls;


            miniRenderer.physicallyCorrectLights = true;
            miniRenderer.outputEncoding = THREE.sRGBEncoding;
            miniRenderer.setClearColor(0x99cccc);
            //像素
            miniRenderer.setPixelRatio(window.devicePixelRatio);
            miniRenderer.setSize(miniCW, miniCH);
            miniRenderer.render(miniScene, miniCamera);
            MC.appendChild(miniRenderer.domElement);

            let miniAnimate = function () {
                requestAnimationFrame(miniAnimate);

                miniControls.update();

                miniRenderer.render(miniScene, miniCamera);
            };
            miniAnimate();

        }
    }

    handleOk() {
        this.setState({
            isModalVisible: false
        })
    }


    render() {
        return (
            <div>
                <div id="zrf" style={{ width: '100%', height: window.innerHeight }} ></div>

                <Modal title={this.pickObj && this.pickObj.name} visible={this.state.isModalVisible}
                    closable={false}
                    onOk={this.handleOk}
                    maskClosable={false}
                    style={{ top: 10, float: 'right', right: 10 }}
                    width={500}
                    footer={[
                        <Button key="sure" type="primary" onClick={this.handleOk.bind(this)} style={{ marginTop: -10, marginBottom: -10 }}>
                            确定
                        </Button>
                    ]}>
                    <div
                        id="minicanvas"
                        style={{ width: '100%', height: 300, background: '#888', marginTop: -20 }}
                    />
                    剩余寿命：
                    <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a" status="active" steps={10} style={{ marginLeft: 10 }} />
                    <Card>
                        <Statistic
                            style={{ margin: -15 }}
                            title="保养周期："
                            value={3}
                            precision={1}
                            valueStyle={{ color: '#cf1322' }}
                            prefix={<>&darr;</>}
                            suffix="个月"
                        />
                    </Card>

                    <Timeline style={{ marginBottom: -70, marginTop: 10 }}>
                        <Timeline.Item style={{ marginBottom: -10 }}>{'上次保养 2020-10-22'} </Timeline.Item>
                        <Timeline.Item >{'下次保养 2021-01-22'} </Timeline.Item>
                    </Timeline>

                </Modal>
            </div>
        );
    }
}

export default Test;
